import React, { useState, useEffect } from 'react';
import { GenericPageLayout } from 'layouts/genericPage.layout';
import { FaceDissatisfied, HighFive } from '@carbon/pictograms-react';
import lodash from 'lodash';

export const Message: React.FC<{}> = () => {
  const [message, setMessage] = useState<string>('');
  const [messageType, setMessageType] = useState<string>();
  const _: any = lodash;
  // EFFECTS
  useEffect(() => {
    const locParams: any = _.chain(window.location.href)
      .split('?')
      .nth(1)
      .split('&')
      .map(_.partial(_.split, _, '=', 2))
      .fromPairs()
      .value();

    if (locParams) {
      const _message = locParams['message']?.indexOf('+')
        ? locParams['message'].replaceAll('+', ' ')
        : locParams['message'];
      setMessage(decodeURIComponent(_message || ''));
      setMessageType(locParams['type']);
    }
  }, [_]);

  return (
    <div id="message-page" className="message-page" data-testid="messagePage">
      <GenericPageLayout
        pageClassName="message-page--wrapper"
        bodyFooterIcon={
          messageType === 'success' ? (
            <HighFive className="success" />
          ) : messageType === 'error' ? (
            <FaceDissatisfied className="error" />
          ) : null
        }
      >
        <h1 className="heading--top">{message}</h1>
      </GenericPageLayout>
    </div>
  );
};

Message.displayName = 'Message';
export default Message;
